export var ViewType = /*#__PURE__*/ function(ViewType) {
    ViewType["ProjectList"] = "PROJECT_LIST";
    ViewType["ProjectTaskList"] = "PROJECT_TASK_LIST";
    ViewType["AllTasks"] = "ALL_TASKS";
    ViewType["ResourceManagement"] = "RESOURCE_MANAGEMENT";
    ViewType["ResourceManagementCapacityPlanning"] = "CAPACITY_PLANNING";
    ViewType["TimesheetReports"] = "TIMESHEET_REPORTS";
    ViewType["CsatReports"] = "CSAT_REPORTS";
    ViewType["ProjectPerformanceReports"] = "PROJECT_PERFORMANCE_REPORTS";
    ViewType["PeoplePerformanceReports"] = "PEOPLE_PERFORMANCE_REPORTS";
    ViewType["OperationReports"] = "OPERATION_REPORTS";
    ViewType["IntervalIqReports"] = "INTERVAL_IQ_REPORTS";
    ViewType["ProfitabilityReports"] = "PROFITABILITY_REPORTS";
    ViewType["Dashboard"] = "DASHBOARD_FILTER";
    ViewType["UtilizationReport"] = "UTILIZATION_REPORT";
    ViewType["TimesheetSubmissionReport"] = "TIMESHEET_SUBMISSION_REPORT";
    ViewType["UserTimeAnalyticsReport"] = "USER_TIME_ANALYTICS_REPORT";
    ViewType["ProjectTimeAnalyticsReport"] = "PROJECT_TIME_ANALYTICS_REPORT";
    ViewType["CateogryTimeAnalyticsReport"] = "CATEGORY_TIME_ANALYTICS_REPORT";
    ViewType["SprintList"] = "SPRINT_LIST";
    ViewType["SprintReports"] = "SPRINT_REPORT";
    ViewType["CustomerPorfolioList"] = "COMPANY_LIST";
    ViewType["CustomReport"] = "CUSTOM_REPORT";
    ViewType["SkillMatrix"] = "SKILL_MATRIX";
    ViewType["ResourceRequest"] = "RESOURCE_REQUEST";
    ViewType["ResourceApproval"] = "RESOURCE_APPROVAL";
    ViewType["InvoiceList"] = "INVOICE_LIST";
    ViewType["CreditNoteList"] = "CREDIT_NOTE_LIST";
    ViewType["TimesheetApprovals"] = "TIMESHEET_APPROVALS";
    ViewType["ProjectTimesheetsList"] = "PROJECT_TIMESHEETS_LIST";
    ViewType["TimesheetsList"] = "ACCOUNT_TIMESHEETS_LIST";
    ViewType["EpicList"] = "EPIC_LIST";
    ViewType["BacklogList"] = "BACKLOG_LIST";
    ViewType["MyExpenses"] = "MY_EXPENSES";
    ViewType["ExpenseApprovals"] = "EXPENSE_APPROVALS";
    ViewType["ProjectExpenses"] = "PROJECT_EXPENSES";
    ViewType["MyExpenseReports"] = "MY_EXPENSE_REPORTS";
    ViewType["ExpenseApprovalReports"] = "EXPENSE_APPROVAL_REPORTS";
    // using this for both revenue overview and list page
    ViewType["RevenueView"] = "REVENUE_VIEW";
    ViewType["AllSignal"] = "ALL_SIGNAL";
    return ViewType;
}({});
export var ViewScopeType = /*#__PURE__*/ function(ViewScopeType) {
    ViewScopeType["Self"] = "SELF";
    ViewScopeType["Limited"] = "LIMITED";
    ViewScopeType["Everyone"] = "EVERYONE";
    return ViewScopeType;
}({});
